import { FC } from 'react'
import {
  DefaultFormContainer,
  FlexDiv,
  AddressOptions
} from './styles'
import { LeftBar } from '../../basic/LeftBar'
import OptionButton from '../../basic/OptionButton'
import StandardFormatInput from '../../../components/basic/StandardFormatInput'
import FileData from 'src/dtos/fileData'
import FilePicker from '../../../components/basic/FilePicker'
import { uploadFiles } from '../../../services/apiClient'
import { InsuranceData } from 'src/dtos/applicationData'
import { FormInputErrorMessage } from 'src/components/application/formComponents/styles'
import { error } from 'console'
import { ValidationErrorMessage } from 'src/components/basic/ValidationErrorMessage/ValidationErrorMessage'
import {FILE_SIZE_LABEL} from "../../../utils/constants";

interface CurrentInsuranceInfoProps {
  fileData?: Array<FileData>;
  handleUploadFile: (fileData: FileData[] | undefined) => Promise<void>;
  retroactiveDate?: string;
  selectedOption?: boolean;
  insurance: InsuranceData;
  setInsurance: (insurance: InsuranceData) => void; 
  isIncorrect?: boolean;
  errorCodes?: string[];
}

const CurrentInsuranceInfo: FC<CurrentInsuranceInfoProps> = ({
  fileData,
  handleUploadFile,
  retroactiveDate,
  selectedOption,
  insurance,
  setInsurance,
  isIncorrect,
  errorCodes = ['']
}) => {

  const handleOptionButton = (option: boolean) => {
    if (!!setInsurance){
      if (!option)
        setInsurance({...insurance, isCurrent: option, policyFile: undefined})
      else
        setInsurance({...insurance, isCurrent: option})
    }
  }

  const handleFileSelect = async (files: File[]) => {
    if(files.length > 0) {
      const response = await uploadFiles(files)
      handleUploadFile(response)
    } else {
      handleUploadFile(undefined)
    }
  }

  return (
    <DefaultFormContainer>
      <strong id="current_insurance_question">Is this your current insurance?</strong>
      <AddressOptions>
        <OptionButton
          checked={selectedOption === true}
          onChange={() => handleOptionButton(true)}
          isIncorrect={isIncorrect}
          errorCode={errorCodes[0]}
        >
          Yes
        </OptionButton>
        <OptionButton
          checked={selectedOption === false}
          onChange={() => handleOptionButton(false)}
          isIncorrect={isIncorrect}
          errorCode={errorCodes[0]}
        >
          No
        </OptionButton>
      </AddressOptions>
      <ValidationErrorMessage errorCode={errorCodes[0]} />
      {isIncorrect ? (
        <FormInputErrorMessage>
          This is a required field
        </FormInputErrorMessage>
      ) : null}
      {(true && selectedOption === true) ? (
        <>
          <FlexDiv margin='24px 0 0 0'>
            <LeftBar />
            <div className='content'>
              <StandardFormatInput
                label="What is the policy's retroactive date for prior acts coverage?"
                labelSize='small'
                maskStyle='date'
                value={retroactiveDate}
                onValueChange={({ formattedValue }) => setInsurance({...insurance, retroactiveDate: formattedValue})}
                errorCode={errorCodes[1]}
              />
            </div>
          </FlexDiv>
          <FlexDiv margin='24px 0 0 0'>
            <LeftBar />
            <div className='content'>
              <FilePicker
                accept='.doc,.docx,application/msword, application/pdf'
                title={
                  <>
                    <p>
                      We will need to see a copy of this firm's active insurance information. Please upload a copy of your current policy including the declarations page and all endorsements.
                      <span style={{ color: '#7B7C82' }}> (Optional). {FILE_SIZE_LABEL}</span>
                    </p>
                  </>
                }
                onFilesSelect={handleFileSelect}
                selectedFiles={!!fileData ? fileData : []}
                limit={100}
              />
            </div>
          </FlexDiv>
        </>
      ) : null}
    </DefaultFormContainer>
  )
}

export default CurrentInsuranceInfo